import { ReactNode } from "react";
import { Chip, ChipProps, TooltipProps, Tooltip } from "@mui/material";

export type CoreChipProps = Omit<ChipProps, "variant" | "label" | "children"> & {
	variant?: "rectangular" | "rounded";
	mobileStyling?: boolean;
	children: ReactNode;
	chipColor: string;
	tooltip?: string;
	tooltipProps?: Omit<TooltipProps, "title" | "children">;
};

export default function CoreChip({
	variant = "rounded",
	chipColor,
	mobileStyling,
	sx,
	children,
	tooltip,
	tooltipProps,
	...chipProps
}: CoreChipProps) {
	const chipContent = (
		<Chip
			{...chipProps}
			label={children}
			sx={{
				height: variant === "rectangular" ? "28px" : "22px",
				minWidth: mobileStyling ? `min(100%, 88px)` : "88px",
				fontSize: mobileStyling ? "13px" : "15px",
				fontWeight: mobileStyling ? 400 : 500,
				borderRadius: variant === "rectangular" ? "4px" : "16px",
				...sx,
				"& .css-6od3lo-MuiChip-label": {
					whiteSpace: "wrap",
				},
				backgroundColor: chipColor,
			}}
		/>
	);
	if (!tooltip) return chipContent;
	return (
		<Tooltip {...tooltipProps} title={tooltip}>
			{chipContent}
		</Tooltip>
	);
}
